import { Button } from '@ui';
import { UserBookingList } from 'components/EventCalendar/Booking/UserBookingList';
import { UserSpaceBookingList } from 'components/SpaceBooking';
import dynamic from 'next/dynamic';
import React, { useMemo, useState } from 'react';
import { DataTableContainer } from '~/components/DataTable';

const UserAllocationsList = dynamic(() => import('components/SpaceManager/UserAllocationList'));

interface Props {
    all?: boolean;
}

export const BookingOverview: React.FunctionComponent<
    React.PropsWithChildren<React.PropsWithChildren<Props>>
> = ({}: Props) => {
    const [currentSection, setCurrentSection] = useState<'space-bookings' | 'bookings' | 'space-manager'>(
        'space-bookings'
    );

    const renderCurrentSection = useMemo(() => {
        switch (currentSection) {
            case 'space-bookings':
                return <UserSpaceBookingList />;
            case 'space-manager':
                return <UserAllocationsList />;
            case 'bookings':
                return <UserBookingList />;
        }
    }, [currentSection]);

    return (
        <div className="tw-flex tw-h-[calc(100%-40px)] tw-flex-col">
            <div className="tw-mb-4 tw-flex tw-justify-center tw-gap-4">
                {/* <Button
                    flat
                    size="xs"
                    block
                    color={currentSection === 'space-bookings' ? 'success' : 'light'}
                    onPress={() => setCurrentSection('space-bookings')}
                >
                    Platzbuchungen
                </Button> */}
                <Button
                    flat
                    size="xs"
                    block
                    color={currentSection === 'space-manager' ? 'success' : 'light'}
                    onPress={() => setCurrentSection('space-manager')}
                >
                    Platzbuchungen
                </Button>
                <Button
                    flat
                    size="xs"
                    block
                    color={currentSection === 'bookings' ? 'success' : 'light'}
                    onPress={() => setCurrentSection('bookings')}
                >
                    Buchungen
                </Button>
            </div>
            <DataTableContainer>{renderCurrentSection}</DataTableContainer>
        </div>
    );
};
